import Vue from 'vue'
import Vuetify, { VCardText } from 'vuetify/lib'

Vue.use(Vuetify, {
  components: { VCardText }
})

// IABF 2026 palette (see ~/.claude/projects/.../memory/iabf_2026_brand_colors.md):
//   crimson      #dd4762   ← festival pop, highest-emphasis CTAs
//   orange       #f8722a   ← warnings / energetic accents
//   gold         #f6b252   ← secondary highlights, soft borders
//   light orange #f2cbba   ← background washes
//   azure        #388b9d   ← brand-aligned primary
//   teal         #267E7D   ← persistent IABF identity (links, chrome)
export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#388b9d',
        secondary: '#f6b252',
        accent: '#dd4762',
        error: '#dd4762',
        info: '#388b9d',
        success: '#4CAF50',
        warning: '#f8722a'
      }
    }
  }
})
